import { __assign, __extends } from "tslib";
import React from "react";
import styles from "./PnmacRadioButton.styles.js";
import { Platform } from "react-native";
import RadioButton from "./Platform/RadioButton";
import defaultTheme from "../styles/defaultTheme";
/**

 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { View } from 'react-native';
 * import { RadioButton } from 'pnmac-universal-components';
 *
 * export default class MyComponent extends React.Component {
 *   state = {
 *     checked: 'first',
 *   };
 *
 *   render() {
 *     const { checked } = this.state;
 *
 *     return (
 *       <View>
 *         <RadioButton
 *           value="first"
 *           status={checked === 'first' ? 'checked' : 'unchecked'}
 *           onPress={() => { this.setState({ checked: 'first' }); }}
 *         />
 *         <RadioButton
 *           value="second"
 *           status={checked === 'second' ? 'checked' : 'unchecked'}
 *           onPress={() => { this.setState({ checked: 'second' }); }}
 *         />
 *       </View>
 *     );
 *   }
 * }
 * ```
 */
var PnmacRadioButton = /** @class */function (_super) {
  __extends(PnmacRadioButton, _super);
  function PnmacRadioButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacRadioButton.prototype.render = function () {
    return /*#__PURE__*/React.createElement(RadioButton, __assign({}, this.props, {
      testID: "radioButton"
    }));
  };
  return PnmacRadioButton;
}(React.Component);
export default defaultTheme(PnmacRadioButton);